import React from "react";
import { Link } from "react-router-dom";
import "./components.css";
// import icons pack
import Ionicon from "react-ionicons";
import Logo from "../../assets/images/logo.png";

export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.header = null;
  }
  componentDidMount = () => {
    // add event action on scroll
    this.header = document.getElementsByClassName("header")[0];
    window.addEventListener("scroll", this.headerToggle);
  };
  // navbar show/hide on scroll
  headerToggle = () => {
    let scrollY = window.scrollY;
    if (scrollY > 50) {
      this.header.classList.add("onscroll");
    } else {
      this.header.classList.remove("onscroll");
    }
  };
  render = () => {
    return(
    <div className="header">
      <div className="empty" />
      <div className="logo perfectCenter">
        <img src={Logo} />
      </div>
      <div className="navgitaion">
        <Link to="/login">
          LOGIN
          <Ionicon icon="md-log-in" fontSize="20px" color="#ffffff" />
        </Link>
        <span className="gradientButton buttonSM">
          <Link to="/register">START FOR FREE</Link>
        </span>
      </div>
    </div>
    )
  };
}
